import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { appelerApi, ErreurApi } from "../api/client";
import { utiliserSession } from "../auth/SessionContext";

interface Invitation {
  id: number;
  type: string;
  organisation: { id: number; nom: string; type: string } | null;
  production: { id: number; titre: string; resume_court: string } | null;
  date_expiration: string;
}

export function InvitationPage() {
  const { jeton = "" } = useParams();
  const { session } = utiliserSession();
  const [invitation, definirInvitation] = useState<Invitation | null>(null);
  const [erreur, definirErreur] = useState("");
  const [acceptee, definirAcceptee] = useState(false);
  const [chargement, definirChargement] = useState(true);

  useEffect(() => {
    appelerApi<Invitation>(`/invitations/${jeton}`)
      .then(definirInvitation)
      .catch((cause: unknown) =>
        definirErreur(cause instanceof ErreurApi ? cause.message : "Invitation illisible.")
      )
      .finally(() => definirChargement(false));
  }, [jeton]);

  async function accepter() {
    definirErreur("");
    try {
      await appelerApi(`/invitations/${jeton}/accepter`, { method: "POST" }, true);
      definirAcceptee(true);
    } catch (cause) {
      definirErreur(cause instanceof ErreurApi ? cause.message : "Acceptation impossible.");
    }
  }

  return (
    <section className="page page-invitation">
      <div className="carte-invitation">
        <span className="surtitre">Invitation sécurisée</span>
        {chargement && <p>Vérification de l’invitation…</p>}
        {erreur && <div className="alerte alerte--erreur">{erreur}</div>}
        {invitation && !acceptee && (
          <>
            <h1>{invitation.organisation?.nom ?? "Une organisation"} vous invite</h1>
            <p>
              Cette invitation concerne{" "}
              {invitation.production ? (
                <strong>{invitation.production.titre}</strong>
              ) : (
                "une collaboration sur Tickboss Production"
              )}
              .
            </p>
            <p className="note">
              Elle expire le{" "}
              {new Intl.DateTimeFormat("fr-FR", {
                dateStyle: "long",
                timeStyle: "short"
              }).format(new Date(invitation.date_expiration))}
              .
            </p>
            {session ? (
              <button className="bouton bouton--primaire" type="button" onClick={accepter}>
                Accepter l’invitation
              </button>
            ) : (
              <div className="actions-invitation">
                <Link className="bouton bouton--primaire" to="/connexion">
                  Se connecter pour accepter
                </Link>
                <Link className="bouton bouton--secondaire" to="/inscription">
                  Créer un compte
                </Link>
              </div>
            )}
          </>
        )}
        {acceptee && (
          <div className="etat-vide">
            <strong>Invitation acceptée.</strong>
            <p>L’organisation apparaît désormais dans votre espace.</p>
            <Link className="bouton bouton--primaire" to="/espace">
              Ouvrir mon espace
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
